module.exports = __webpack_public_path__ + "static/media/small-utility.523f6a6d.svg";